module.exports = __webpack_public_path__ + "img/全部中标@3x.e61d7024.png";